import moment from 'moment';
import { deepClone } from '@/helpers/object';

export const appointmentModalTitle = state => (
  `Agendamento - ${moment(state.form.startDate.substring(0, 10))
    .format('dddd, D [de] MMMM [de] YYYY')}`
);

export const isInUseByAnotherUser = (state, getters, { auth }) => (
  state.form.inUseBy && state.form.inUseBy !== auth.user.id
);

export const isBlockedByAnotherUser = (state, getters, { auth }) => {
  if (getters.isInUseByAnotherUser) {
    const { settings } = auth.user.branch;
    return settings && settings['clinical.blockAppointmentInUse'];
  }

  return false;
};

export const getProfessionalById = state => (
  (id, specialties = null) => {
    let professional = state.professionals.find(item => item.id === id);
    if (professional && specialties !== null) {
      professional = deepClone(professional);
      professional.specialties = professional.specialties
        .filter(({ code }) => specialties.includes(code));
    }
    return professional;
  }
);

export const getInsuranceByPlanId = state => (
  (id) => {
    let insurance = state.filter.insurances.find(({ plan }) => plan.id === id);
    if (!insurance) {
      insurance = state.insurances.find(({ plan }) => plan.id === id);
    }
    return insurance || null;
  }
);

export const getScheduleById = state => (
  id => state.schedules.find(item => item.id === id)
);

export const hasClipboardData = state => (
  !!state.clipboard.event && !!state.clipboard.data
);
